import { IconNG } from '../../Icon'
import { getIcon } from '../Notification.utils'

function NotificationIcon({ type, ...restProps }) {
  const Icon = getIcon(type)

  return <IconNG {...restProps} Icon={Icon} />
}

export default NotificationIcon
